import type { PropsWithChildren } from "react";

export const Name = ({ children }: PropsWithChildren) => {
	const name = typeof children === "string" ? children : undefined;
	const formattedName = (() => {
		if (!name) return undefined;
		const arr = name?.split(" - ");
		if (arr?.length === 1) return arr[0];
		arr?.shift();
		return arr?.join(" ");
	})();
	return <p data-layout="name">{formattedName ?? children}</p>;
};
